import React, { useEffect } from 'react';
import '../../StylesCSS/ButtonsLayout.css';
import { School, Home, Input, Language, ArrowBack, Assignment } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import BranchLabelBanner from './BranchLabelBanner';

const PageLayout2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {
        branch,
        branchLabel,
        action,
    } = location.state || {};

    /* Start MSL30082026 */
    useEffect(() => {
        console.log('=== PageLayout2: route context ===');
        console.log('location.state:', location.state);
        console.log('branch:', branch);
        console.log('branchLabel:', branchLabel);
        console.log('action:', action);
    }, [location.state, branch, branchLabel, action]);

    const routeState = {
        branch,
        branchLabel,
        action,
    };

    const handleSectionChange = (route, extraState = {}) => {
        const finalState = {
            ...routeState,
            ...extraState,
        };

        console.log('=== PageLayout2: navigation vers sous-page ===');
        console.log('route:', route);
        console.log('state envoyé:', finalState);

        navigate(`/${route}`, {
            state: finalState,
        });
    };
    /* End MSL30082026 */

    return (
        <div style={{ maxWidth: '600px', margin: 'auto', textAlign: 'center' }}> {/* Centre le contenu */}
        <br></br>
        <div
          style={{
            display: "flex",
            justifyContent: "center", // Centrage horizontal
            alignItems: "center",

            backgroundColor: "#00B9B9",
            padding: "16px",
            borderRadius: "8px",
            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
            direction: "rtl",
            fontFamily: "Arial, sans-serif",
            fontSize: "22px",
            fontWeight: "bold",
            height: "80px",
            gap: "20px",
          }}
        >
          {/* Carré à droite (début de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>

          {/* Texte arabe centré */}
          <span>تدبير مجالس الأقســــام للجدع المشترك</span>

          {/* Carré à gauche (fin de ligne en arabe) */}
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: "#FF9900",
              borderRadius: "2px",
            }}
          ></div>
        </div>
        <BranchLabelBanner branchLabel={branchLabel} style={{ marginTop: '12px' }} />
        <br></br>
            <h2 style={{ textAlign: 'right' }}> : تدبير مجالس الأقســــام </h2>
            <div className="buttons-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}> {/* Conteneur centré */}
                {/* Button: المؤسسة الأصلية */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('OriginalInstitutionV2', { action: 'originalInstitution' })}
                    style={{
                        backgroundColor: '#33B5E6', // Couleur spécifique
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%', // Largeur des boutons pour uniformité
                        maxWidth: '400px', // Limite la taille des boutons
                    }}
                >
                    <School style={{ marginRight: '8px' }} /> {/* Icône */}
                    المؤسسة الأصلية
                </button>

                {/* Button: مؤسسة الاستقبال */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('EtablissementAccueilV2', { action: 'receptionInstitution' })}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Home style={{ marginRight: '8px' }} />
                    مؤسسة الاستقبال
                </button>

                {/* Button: ادخال العتبة */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('LeSeuilV2', { action: 'threshold' })}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Input style={{ marginRight: '8px' }} />
                    ادخال العتبة
                </button>

                {/* Button: ادخال الملاحظات */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('InputNotesV2', { action: 'notes' })}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Input style={{ marginRight: '8px' }} />
                    ادخال الملاحظات
                </button>

                {/* Button: ادخال اللغة الاجنبية الثانية */}
                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('DeuxiemeLangueSelonDepartementV2', { action: 'language' })}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Language style={{ marginRight: '8px' }} />
                    ادخال اللغة الاجنبية الثانية حسب القسم
                </button>

                <button
                    className="btn btn-right"
                    onClick={() => handleSectionChange('DecisionConseilSelonDepartementV2', { action: 'decisionByClass' })}
                    style={{
                        backgroundColor: '#33B5E6',
                        color: 'white',
                        padding: '10px 20px',
                        margin: '10px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                >
                    <Assignment style={{ marginRight: '8px' }} />
                    اختيار قرار المجلس حسب القسم
                </button>

                {/* Button: Retour */}
                <button
                    className="btn btn-left"
                    style={{
                        backgroundColor: '#FF6347', // Couleur spécifique pour le bouton retour
                        color: 'white',
                        padding: '10px 20px',
                        margin: '20px 0',
                        borderRadius: '8px',
                        border: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        maxWidth: '400px',
                    }}
                    onClick={() => handleSectionChange('PageLayoutActionsV2', { action: 'backToSelection' })}
                >
                    <ArrowBack style={{ marginRight: '8px' }} />
                    Retour
                </button>
            </div>
        </div>
    );
};

export default PageLayout2;
